import { AxiosResponse } from 'axios';
import api from './Api'

export const getTicketGiftByCode = (code: string): Promise<AxiosResponse<ITicketGift>> =>
    api.get(`/ticket-gift/web/v2/${code}`);

export const claimTicketGiftByCode = (code: string): Promise<AxiosResponse<ITicketGiftUseResponse>> =>
    api.post(`/ticket-gift/use/web/v2`, { code });
